
import logo from './assets/chirptasklogo-dark-horizontal.png'

const Footer = () => {
  return (
    <> 
      <footer>
        <div class="container text-center">
          <div class="row">
            <div class="col">
              <img class="logo" src={logo} height="75"/>
            </div>
            <div class="col">
              
            </div>
            <div class="col">
              © Copyright 2025 ChirpTask
            </div>
          </div>
        </div>
  </footer>
    </>
  );
};

export default Footer;




